import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

type TacticalButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'destructive'
  size?: 'sm' | 'default' | 'lg'
  loading?: boolean
}

const variantStyles = {
  primary:
    'border-primary/20 bg-primary/10 text-primary hover:bg-primary/20 hover:border-primary/30 hover:shadow-[0_0_20px_rgba(99,215,6,0.15)] active:bg-primary/25',
  secondary:
    'border-white/[0.08] bg-white/[0.03] text-foreground hover:bg-white/[0.06] hover:border-white/[0.12] active:bg-white/[0.08]',
  ghost:
    'border-transparent bg-transparent text-muted-foreground hover:text-foreground hover:bg-white/[0.04] active:bg-white/[0.06]',
  destructive:
    'border-destructive/20 bg-destructive/10 text-destructive hover:bg-destructive/20 hover:border-destructive/30 active:bg-destructive/25',
}

const sizeStyles = {
  sm: 'px-3 py-1.5 text-xs gap-1.5',
  default: 'px-4 py-2 text-sm gap-2',
  lg: 'px-5 py-2.5 text-sm gap-2',
}

export function TacticalButton({
  children,
  className,
  variant = 'primary',
  size = 'default',
  loading = false,
  disabled,
  ...rest
}: TacticalButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center border rounded-lg font-medium',
        'transition-all duration-150',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none',
        'active:scale-[0.98]',
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  )
}
